import { DateTime } from "luxon";

let date_format = {
  dateUtcToThaiFormat(value, from = "sql") {
    if (!value) return "";

    let date = {};

    if (from == "sql") date = DateTime.fromSQL(value);
    else if (from == "iso") date = DateTime.fromISO(value);

    return date.setLocale("th-TH").toLocaleString({
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  },
  dateTimeUtcToThaiFormat(value, from = "sql") {
    if (!value) return "";

    let date = {};

    if (from == "sql") date = DateTime.fromSQL(value);
    else if (from == "iso") date = DateTime.fromISO(value);

    return date.setLocale("th-TH").toLocaleString({
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "numeric"
    });
  }
};

export { date_format };
